import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import ChatIcon from "../resources/chat.svg.js";
import CloseIcon from "../resources/CloseFilled.svg.js";
const ChatButton = (props) => {
  return /* @__PURE__ */ jsx(
    "button",
    {
      onClick: props.isChatPanelOpen ? props.onCloseClick : props.onOpenClick,
      className: "chat-button",
      children: props.isChatPanelOpen ? /* @__PURE__ */ jsx("img", { alt: "Minimize Chat", src: CloseIcon }) : /* @__PURE__ */ jsx("img", { alt: "Maximize Chat", src: ChatIcon })
    }
  );
};
ChatButton.propTypes = {
  isChatPanelOpen: PropTypes.bool,
  onOpenClick: PropTypes.func,
  onCloseClick: PropTypes.func
};
export {
  ChatButton as default
};
//# sourceMappingURL=ChatButton.js.map
